import { observer, Provider } from 'mobx-react';
import {observable} from 'mobx'
import * as React from 'react';
import AccessControlService, { TACLEntities } from '../services/accessControl.service';

class ACLRoot {
  @observable acl: AccessControlService;
  constructor() {
    this.acl = new AccessControlService();
  }
}

const store = new ACLRoot();

interface AccessControlProviderProps {
  /**
   * @param курс или группа
   */
  course_id: number | string;
  // entity?: TACLEntities;
}

export const AccessControlProvider: React.FC<AccessControlProviderProps> = observer(({course_id, children}) => {

  React.useEffect(() => {
    if (course_id) {
      store.acl.byCourse(course_id);
    }

  }, []);

  if (store.acl.loading) {
    return null;
  }
  return (
    <Provider {...store}>
      {children}
    </Provider>
  )
})